import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { TicketListAvailable_BillingPage_Query } from "./query";

type Props = { hotelID: string };

export const useFetchTicketBasicListAvailable = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(TicketListAvailable_BillingPage_Query, {
		variables: {
			hotelID,
		},
	});

	return { data };
};
